import { render, staticRenderFns } from "./BalanceGT_.vue?vue&type=template&id=32e51613&scoped=true&"
import script from "./BalanceGT_.vue?vue&type=script&lang=ts&"
export * from "./BalanceGT_.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceGT_.vue?vue&type=style&index=0&id=32e51613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e51613",
  null
  
)

export default component.exports